import React from "react";

import "./About.css";

function About() {
  return (
    <section className="about light" id="about">
      <div className="content wrapper">
        <h2>О проекте</h2>
        <p>
          <b>Spirit Stones</b> — это натуральные камни для охлаждения напитков.
        </p>
        <p>
          Мы верим, что предметы могут быть не только функциональными, но и
          живыми — с формой, текстурой и историей.
        </p>
        <p>В отличие от стандартных чёрных кубиков, наши камни:</p>
        <ul>
          <li>имеют природную форму, а не искусственную геометрию</li>
          <li>отличаются друг от друга: каждый камень уникален</li>
          <li>можно подобрать к напитку по цвету, смыслу или ощущению</li>
        </ul>
        <p>
          Мы работаем только с натуральным камнем, тщательно отбирая и
          подготавливая каждый экземпляр.
        </p>
        <h3>Безопасность и подготовка</h3>
        <p>Все камни:</p>
        <ul>
          <li>очищены и отполированы</li>
          <li>не имеют острых краёв и трещин</li>
          <li>подходят для контакта с напитками</li>
        </ul>
        <p>
          Перед использованием камни достаточно охладить в морозильной камере.
        </p>
        <h3>Для чего это</h3>
        <p>
          <b>Spirit Stones</b> — это:
        </p>
        <ul>
          <li>альтернатива льду</li>
          <li>эстетичный ритуал</li>
          <li>подарок с характером</li>
        </ul>
        <p>
          Это не про скорость и массовость. Это про ощущение, внимание и вкус.
        </p>
        <h3>Идея для подарка</h3>
        <p>
          Spirit Stones можно подарить как самостоятельный предмет или дополнить
          ими напиток, который вы выбираете с вниманием.
        </p>
        <p>
          Камни не привязаны к конкретному бренду или бутылке, они остаются с
          человеком и могут использоваться снова и снова.
        </p>
        <h3>О наборах и сочетаниях</h3>
        <p>Камни можно собрать по-разному.</p>
        <p>Например, выбрать один вид для цельного, спокойного образа. </p>
        <p>
          Или собрать набор для компании из нескольких пород, чтобы каждый мог
          выбрать камень по настроению.
        </p>
      </div>
    </section>
  );
}

export default About;
